export const FILTERS_NOT_FOR_DISPLAY = [
  'booked',
  'dataSource',
  'ordering',
  'page',
  'price_type',
  'searchOrigin',
  'seed',
  'sort',
];

export const filterKeys = [
  'dealer-id',
  'emission-sticker',
  'engine-power__gte',
  'engine-power__lte',
  'engine-size__gte',
  'engine-size__lte',
  'ev-wltp-range__gte',
  'ev-wltp-range__lte',
  'filter-only',
  'fuel-type',
  'gear-box',
  'monthly-price__gte',
  'monthly-price__lte',
  'price-reduced',
  'reduced-content',
  'body-type',
  'color',
  'heycar-id',
  'max-distance',
  'd2c',
  'rac',
  'doors',
  'ecom',
  'make',
  'lat',
  'lon',
  'mileage__gte',
  'mileage__lte',
  'model',
  'variant-type',
  'stock-condition',
  'nuts-label',
  'nuts1-code',
  'page',
  'postcode',
  'price__gte',
  'price__lte',
  'seats',
  'sort',
  'year__gte',
  'year__lte',
  'region',
  'area',
  'finance-product',
  'eligible-products',
  'new-car-eu24',
  'vehicle-status',
  // seo filters
  'dealership-id',
  'has-offers-or-promotions',
  'fuel-consumption__gte',
  'fuel-consumption__lte',
  // wholesale
  'registration',
  'location',
  'v5',
  'mot',
  'ending-soon',
  'vat-status',
  'sold-as-seen',
  'keepers-count',
  'auction-grade',
  'cap__gte',
  'cap__lte',
];
